import Link from "next/link";
import React from "react";
import {
  EmptyPhoto,
  ParticipantImageWrapper,
  ParticipantWrapper
} from "./styles";

const Participant = ({ id, name, country, city, imageSrc }) => (
  <Link href={`/artists/${id}`} passHref>
    <ParticipantWrapper>
      {imageSrc ?
        <ParticipantImageWrapper>
          <svg width="100%" height="100%" viewBox="0 0 230 230" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="230" height="230">
              <path d="M230 230H0V0H115H146.74L230 22.54V230Z" fill="#67DBCA"/>
            </mask>
            <g mask="url(#mask0)">
              <image href={imageSrc} width='230' height='230' preserveAspectRatio="xMidYMid slice"/>
            </g>
            <path xmlns="http://www.w3.org/2000/svg" d="M147.74 1.52588e-05L230 22.24L198.72 33.58L146.74 1.52588e-05Z"
                  fill="#21CEB4"/>
          </svg>
        </ParticipantImageWrapper>
        :
        <EmptyPhoto />
      }
      {name &&
        <span className='participant-name'>{name}</span>
      }
      {(country || city) &&
        <span className='participant-city'>{country}{country && city && ' / '}{city}</span>
      }
    </ParticipantWrapper>
  </Link>
);

export default Participant;
